// extracted by mini-css-extract-plugin
export default {"wrapper":"UploadProgress_wrapper__malqO","closeButton":"UploadProgress_closeButton__yWSbv"};